<template>
    <main class="bg-white rounded-xl shadow-md overflow-hidden">
        <!-- Header -->
        <div class="bg-gradient-to-r from-[#E07B39] to-[#8B5A87] text-white px-6 sm:px-8 lg:px-12 py-6 lg:py-8 relative">
            <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between max-w-7xl mx-auto">
                <h1 class="text-3xl md:text-3xl font-bold mb-2">Nos événements</h1>

                <!-- Compteur -->
                <div class="flex items-center space-x-2 lg:space-x-4">
                    <span class="text-sm lg:text-base">Trier par</span>
                    <div class="bg-[#8B5A87] rounded-lg border border-white p-3 lg:p-4">
                        <div class="flex items-center space-x-2 text-sm lg:text-base">
                            <span class="text-white">Événements trouvés</span>
                            <span class="font-bold text-white text-lg lg:text-xl">{{ computedEvents?.length }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Grille -->
        <div class="p-6 lg:p-8 xl:p-12">
            <!-- Grille des événements -->
            <div
                v-if="!loading && limitedEvents.length > 0"
                class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-8 justify-center"
            >
                <XEventCard
                    v-for="item in limitedEvents"
                    :key="item.id"
                    :category="item.event_type"
                    @action="navigator(item)"
                    :title="item.title"
                    :source="item.image ? asset('storage/' + item.image) : asset('images/event.jpg')"
                    :description="cleanDescription(item.description)"
                    :date="item.start_date"
                    :end-date="item.end_date"
                    class=" scale-105 hover:scale-110 transition duration-300"
                />
            </div>

            <!-- Skeleton loading -->
            <div
                v-else-if="loading"
                class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-8 justify-center"
            >
                <XEventCard v-for="i in 4" :key="i" :loading="true" :source="asset('images/event.jpg')" />
            </div>

            <!-- État vide -->
            <div v-else class="text-center py-12 lg:py-16 px-4">
                <div class="max-w-md mx-auto">
                    <div class="w-24 h-24 lg:w-32 lg:h-32 mx-auto mb-6 bg-gradient-to-br from-[#E07B39] to-[#8B5A87] rounded-full flex items-center justify-center">
                        <svg class="w-12 h-12 lg:w-16 lg:h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                        </svg>
                    </div>
                    <h3 class="text-xl lg:text-2xl font-bold text-gray-900 mb-2">Aucun événement disponible</h3>
                    <p class="text-gray-600 lg:text-lg">Revenez bientôt pour découvrir nos prochains événements !</p>
                </div>
            </div>

            <!-- Bouton Voir plus -->
            <div v-if="computedEvents.length > 4" class="mt-8 text-center">
                <button
                    @click="goToAllEvents"
                    class="px-6 py-3 bg-[#2A4493] text-white font-semibold rounded-lg shadow-md hover:bg-[#1E326B] transition"
                >
                    Voir plus d'événements
                </button>
            </div>
        </div>
    </main>
</template>

<script setup>
import { computed } from "vue";
import XEventCard from "@/vue/Public/XEventCard.vue";
import { asset, route } from "@/helper.js";

const props = defineProps({
    events: {
        type: [Array, Object, null],
        default: () => []
    },
    loading: {
        type: Boolean,
        default: false
    }
})

const navigator = (item) => {
    window.location.href = route('events.detail', {event: item.id});
}

const computedEvents = computed(() => props.events || [])

const limitedEvents = computed(() => computedEvents.value.slice(0, 4))

const cleanDescription = (str) => {
    if (!str) return '';
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    const decoded = txt.value;
    return decoded.replace(/<\/?[^>]+(>|$)/g, "");
}

// Bouton Voir plus
const goToAllEvents = () => {
    window.location.href = route('events.index')
}
</script>
